import { render, staticRenderFns } from "./bullObservation.vue?vue&type=template&id=457cda87&scoped=true&"
import script from "./bullObservation.vue?vue&type=script&lang=js&"
export * from "./bullObservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457cda87",
  null
  
)

export default component.exports